import { BMPrimitives, BMText } from "@traveloka/district-bloom";
import { useEffect, useState } from "react";
import { StyleSheet } from "react-native";
import BMView from "../../../../components/View/BMView";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { formatMessage } from "../../../../utils";
import ErrorPage from "../../common/ErrorPage";
import { HotelSearchFormResource } from "../types";
import SearchResultItem from "./SearchResultItem";
import { HotelSearchResponseItem } from "./types";

type Props = {
  searchResults: HotelSearchResponseItem[];
  query: string;
  resource: HotelSearchFormResource;
  isError: boolean;
  onCloseDialog: () => void;
};

export default function SearchResult(props: Props) {
  const { searchResults, query, resource, isError, onCloseDialog } = props;
  const { CorporateHotelSearchForm, CorporateGeneralErrorMessage } =
    useMobileContentResource();
  const [exactSearchIndex, setExactSearchIndex] = useState(-1);
  useEffect(() => {
    if (query && searchResults.length) {
      setExactSearchIndex(
        searchResults.findIndex(
          (item) => item.name.toLocaleLowerCase() === query.toLocaleLowerCase()
        )
      );
    }
  }, [searchResults, query]);

  const hasExactSearch = exactSearchIndex !== -1;

  const otherResults = hasExactSearch
    ? searchResults.filter((_, index) => index !== exactSearchIndex)
    : searchResults;

  const errorImage = resource.image.systemError;
  return (
    <BMView style={styles.container}>
      {!isError ? (
        !!searchResults.length && (
          <>
            {hasExactSearch && (
              <BMView>
                <SearchResultItem
                  query={query}
                  item={searchResults[exactSearchIndex]}
                  onCloseDialog={onCloseDialog}
                />
              </BMView>
            )}
            <BMView>
              <BMText
                style={{
                  marginTop: hasExactSearch ? BMPrimitives.BMSize.xl : 0,
                }}
              >
                {formatMessage(CorporateHotelSearchForm.otherResults, {
                  keyword: query,
                })}
              </BMText>
              <BMView spacing="sm" style={styles.otherResults}>
                {otherResults.map((result) => (
                  <SearchResultItem
                    key={result.id}
                    query={query}
                    item={result}
                    onCloseDialog={onCloseDialog}
                  />
                ))}
              </BMView>
            </BMView>
          </>
        )
      ) : (
        <ErrorPage
          image={errorImage}
          title={CorporateGeneralErrorMessage.fullPageTitle}
          caption={CorporateGeneralErrorMessage.fullPageDescription}
        />
      )}
    </BMView>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingHorizontal: BMPrimitives.BMSize.lg,
    marginTop: BMPrimitives.BMSize.lg,
  },
  otherResults: {
    marginTop: BMPrimitives.BMSize.md,
  },
});
